import config from '@/config';

export default (url: string): string => {
  return config.api.baseUrlClickout + config.api.basePaths.clickout + '?u=' + encodeURIComponent(url);
};
